<template>
  <div class="relative">
    <button
      type="button"
      class="text-ontick-carbon-900 focus:border-ontick-blue-600 focus:ring-ontick-blue-600 dark:bg-ontick-graphite-500 relative flex w-full min-w-[250px] cursor-default items-center bg-gray-300 py-2 pl-3 pr-10 text-left shadow-sm focus:outline-none focus:ring-1 dark:text-gray-300 sm:text-sm"
      @click="is_options_expanded = !is_options_expanded"
      @blur="is_options_expanded = false"
      :class="is_options_expanded ? 'rounded-t-md' : 'rounded-md'"
      aria-haspopup="listbox"
      aria-expanded="true"
      aria-labelledby="listbox-label"
    >
      <span
        v-show="
          parameterSettings.some(
            (x) => x.running == true && x.param_id == selectedParameter.param_id
          )
        "
        class="text-ontick-green-600 absolute inset-y-0 left-0 flex items-center px-2"
      >
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
      <span class="block truncate pl-5 pr-1">
        {{ selectedParameter.param_name }}
      </span>
      <span class="text-xs font-bold">(#{{ selectedParameter.param_id }})</span>
      <span
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
      >
        <svg
          fill="none"
          viewBox="0 0 24 24"
          stroke="#a0aec0"
          class="h-4 w-4 transform transition-transform duration-100 ease-in-out"
          :class="is_options_expanded ? 'rotate-180' : 'rotate-0'"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </span>
    </button>

    <transition
      enter-active-class="transform transition duration-300 ease-custom"
      enter-class="-translate-y-1/2 scale-y-0 opacity-0"
      enter-to-class="translate-y-0 scale-y-100 opacity-100"
      leave-active-class="transform transition duration-300 ease-custom"
      leave-class="translate-y-0 scale-y-100 opacity-100"
      leave-to-class="-translate-y-1/2 scale-y-0 opacity-0"
    >
      <ul
        class="text-ontick-carbon-900 dark:bg-ontick-steel-500 absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-gray-300 py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:text-gray-300 sm:text-sm"
        v-show="is_options_expanded"
        tabindex="-1"
        role="listbox"
      >
        <li
          v-for="(param, index) in parameterSettings"
          :key="index"
          class="dark:hover:bg-ontick-steel-700 relative cursor-pointer select-none py-2 pl-8 pr-4 hover:bg-gray-400"
          role="option"
          @mousedown.prevent="setOption(param)"
        >
          <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
          <span class="block truncate font-normal"
            >{{ param.param_name }} (#{{ param.param_id }})
          </span>
          <span
            v-show="param.running"
            class="text-ontick-green-600 absolute inset-y-0 left-0 flex items-center pl-1.5"
          >
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
        </li>
        <li v-if="typeSelect" @mousedown.prevent="createSetting()">
          <div
            @click="createSetting()"
            class="flex cursor-pointer items-center justify-center py-3"
          >
            <span class="text-ontick-blue-700 pr-1" v-html="$icons.plus"></span>
            Nova configuração
          </div>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "select-setting",
  props: {
    type: {
      type: String,
      default: "normal",
      validator: function (value) {
        return ["normal", "setting"].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      is_options_expanded: false,
      selected: "",
    };
  },
  computed: {
    ...mapGetters({
      getParameters: "investment/getParameters",
      selected_account: "accountTypes/getSelectedAccount",
    }),
    parameterSettings() {
      return this.getParameters.parameterSettings;
    },
    selectedParameter() {
      return this.getParameters.selectedParameter;
    },
    typeSelect() {
      return this.type == "setting" ? true : false;
    },
  },
  methods: {
    createSetting() {
      this.$emit("create-setting");
      this.is_options_expanded = false;
    },
    setOption(option) {
      this.$emit("change", option);
      this.is_options_expanded = false;
    },
  },
};
</script>

<style scoped>
.ease-custom {
  transition-timing-function: cubic-bezier(0.61, -0.53, 0.43, 1.43);
}
</style>
